import { IKhoanNopGroupSelectByHocSinhRequest } from "../../../api/dich-vu/khoanNopGroupApi";
import { ISaleSetRegisterDichVuInsertMultipleRequest } from "../../../api/dich-vu/saleSetRegisterDichVuApi";
import { IDichVuSelectRequest } from "../../../models/request/dich-vu/dichVuRequests";
import { KhoanNopStatusItemResponse } from "../../../models/response/dich-vu/sf_khoannop_group";
import { SaleSetRegisterDichVuItemResponse } from "../../../models/response/dich-vu/sf_saleset_register_dichvu";
import {
	eSaleSetRegisterDichVuActionTypeIds,
	IKhoanNopGroupByHocSinhChange,
	IKhoanNopGroupByHocSinhLoadErr,
	IKhoanNopGroupByHocSinhLoadStart,
	IKhoanNopGroupByHocSinhLoadSuccess,
	ISaleSetRegisterDichVuChangeSelectedIds,
	ISaleSetRegisterDichVuCloseDetail,
	ISaleSetRegisterDichVuLoadErr,
	ISaleSetRegisterDichVuLoadStart,
	ISaleSetRegisterDichVuLoadSuccess,
	ISaleSetRegisterDichVuSaveErr,
	ISaleSetRegisterDichVuSaveStart,
	ISaleSetRegisterDichVuSaveSuccess,
	ISaleSetRegisterDichVuShowDetail
} from "../../action-types/dich-vu/ISaleSetRegisterDichVuActionTypes";

export const saleSetRegisterDichVuActions = {
	loadSaleSetRegisterDichVuStart: (request: IDichVuSelectRequest): ISaleSetRegisterDichVuLoadStart => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadSaleSetRegisterDichVuSuccess: (data: SaleSetRegisterDichVuItemResponse[]): ISaleSetRegisterDichVuLoadSuccess => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadSaleSetRegisterDichVuError: (message: string): ISaleSetRegisterDichVuLoadErr => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadKhoanNopGroupByHocSinhStart: (request: IKhoanNopGroupSelectByHocSinhRequest): IKhoanNopGroupByHocSinhLoadStart => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_START,
			payload: request
		}
	},
	loadKhoanNopGroupByHocSinhSuccess: (data: KhoanNopStatusItemResponse[]): IKhoanNopGroupByHocSinhLoadSuccess => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_SUCCESS,
			payload: data
		}
	},
	loadKhoanNopGroupByHocSinhError: (message: string): IKhoanNopGroupByHocSinhLoadErr => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_ERROR,
			payload: message
		}
	},
	changeKhoanNopGroupByHocSinh: (data: KhoanNopStatusItemResponse[]): IKhoanNopGroupByHocSinhChange => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.CHANGE_KHOANNOP_BY_HOCSINH,
			payload: data
		}
	},
	showSaleSetRegisterDichVuDetail: (data?: SaleSetRegisterDichVuItemResponse): ISaleSetRegisterDichVuShowDetail => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeSaleSetRegisterDichVuDetail: (): ISaleSetRegisterDichVuCloseDetail => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.CLOSE_DETAIL
		}
	},
	changeSaleSetRegisterDichVuSelectedIds: (ids: number[]): ISaleSetRegisterDichVuChangeSelectedIds => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	saveSaleSetRegisterDichVuStart: (request: ISaleSetRegisterDichVuInsertMultipleRequest): ISaleSetRegisterDichVuSaveStart => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.SAVE_START,
			payload: request
		}
	},
	saveSaleSetRegisterDichVuSuccess: (): ISaleSetRegisterDichVuSaveSuccess => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.SAVE_SUCCESS
		}
	},
	saveSaleSetRegisterDichVuError: (message: string): ISaleSetRegisterDichVuSaveErr => {
		return {
			type: eSaleSetRegisterDichVuActionTypeIds.SAVE_ERROR,
			payload: message
		}
	}
}
